import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  numberOfAttendances: { id: 'dashboard.locations.presents', defaultMessage: 'obecnych' },
  numberOfLate: { id: 'dashboard.locations.lateAmount', defaultMessage: 'liczba spóźnień' },
  frequency: { id: 'dashboard.locations.frequency', defaultMessage: 'frekwencja' },
  absences: { id: 'dashboard.locations.absences', defaultMessage: 'urlopy' },
});
